import { MediaGallery } from './media-gallery.js';

/**
 * AI Photos Media Gallery Component
 *
 * Extends MediaGallery for AI Photos products that display before/after
 * comparison sliders within mock frames. The before/after rendering is
 * handled in Liquid via ai-photos-mock-image.liquid snippet.
 *
 * Key differences from standard MediaGallery:
 * - No photo upload integration (photos come from product metafields)
 * - Before/after images are static per product (not user-uploaded)
 * - Mock selection follows standard tier/configurator system
 */
class AiPhotosMediaGallery extends MediaGallery {
  /**
   * Returns null since AI Photos don't use uploaded photos.
   * Before/after images come from product metafields.
   * @returns {null}
   */
  _getUploadedPhotoUrl() {
    return null;
  }

  /**
   * AI Photos always show comparison regardless of upload state.
   * @returns {boolean} Always false - no upload-based photo.
   */
  _hasUploadedPhoto() {
    return false;
  }

  /**
   * No special preparation needed before variant change.
   * The before/after images stay the same; only mock frames change.
   */
  _beforeVariantChange(variantId) {
    // No loading overlay needed - before/after images don't change
  }

  /**
   * No async dependencies to wait for.
   */
  async _waitForVariantDependencies() {
    // No photo crop or upload to wait for
  }

  /**
   * No cleanup needed after variant change.
   */
  _afterVariantChange() {
    // No loading overlay to hide
  }

  /**
   * Prevent JavaScript from updating gallery mocks.
   * AI Photos renders before/after comparison in Liquid, which should be preserved.
   * The mock frame is rendered server-side and doesn't need JS updates.
   * @returns {boolean} Always false - preserve Liquid-rendered content.
   */
  _shouldUpdateGalleryMocks() {
    return false;
  }
}

customElements.define('ai-photos-media-gallery', AiPhotosMediaGallery);

export { AiPhotosMediaGallery };
